var render, staticRenderFns
import script from "./stepUiMixin.vue?vue&type=script&lang=js&"
export * from "./stepUiMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c83eaa2')) {
      api.createRecord('1c83eaa2', component.options)
    } else {
      api.reload('1c83eaa2', component.options)
    }
    
  }
}
component.options.__file = "src/views/taskMgr/templateMgr/components/stepUiMixin.vue"
export default component.exports